<template>
  <v-btn
    color="success"
    small
    @click="downloadCSV"
  >
    Download Jobs CSV
  </v-btn>
</template>

<script>
import { mapState } from 'vuex';

import { downloadFileWithDisposition, CSV_FILE_TYPE, wrapToLoadingFn } from '@helpers';

import { LOCATIONS_NAMESPACE } from '@store/modules/locations.types';

import { DashboardApiService } from '../_services/dashboard.api.service';

export default {
  name: 'PbDashboardJobsCsvDownloader',

  props: {
    machineCategory: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState(LOCATIONS_NAMESPACE, ['suffix']),
  },

  methods: {
    downloadCSV() {
      this.wrapToLoadingFn({
        req: DashboardApiService.downloadJobsCsv.bind({}, {
          machineCategory: this.machineCategory,
          suffix: this.suffix,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: r => downloadFileWithDisposition({
          ...r,
          type: CSV_FILE_TYPE,
          defaultFileName: 'jobs.csv',
        }),
      });
    },

    wrapToLoadingFn,
  },
};
</script>
